import React from 'react'
import {
    EditorState, ContentState, RichUtils, convertFromHTML,
    convertToRaw, convertFromRaw, Modifier, CompositeDecorator
} from 'draft-js';
//import draftToHtml from 'draftjs-to-html';
import { stateToHTML } from "draft-js-export-html";
import Editor, { createEditorStateWithText } from '@draft-js-plugins/editor';
import createHashtagPlugin, { extractHashtagsWithIndices } from '@draft-js-plugins/hashtag';
import '@draft-js-plugins/hashtag/lib/plugin.css';

import createEmojiPlugin from '@draft-js-plugins/emoji';
//import '@draft-js-plugins/emoji/lib/plugin.css';
import './emoji.css';

import createLinkifyPlugin, { extractLinks } from '@draft-js-plugins/linkify';
//import UploadComponent from './UploadComponent';
//import "./uploadfilestyles.css";
import createMentionPlugin, {
    defaultSuggestionsFilter
} from "@draft-js-plugins/mention";

import "draft-js/dist/Draft.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import '@draft-js-plugins/linkify/lib/plugin.css';
import $ from 'jquery';
import moment from 'moment';
import noImage from './../../assets/images/no_image.png';
import Jscontentloader from './jscontentloader';
const mentionPlugin = createMentionPlugin({ mentionPrefix: "@" });
const { MentionSuggestions } = mentionPlugin;

const hashtagPlugin = createHashtagPlugin();
const linkifyPlugin = createLinkifyPlugin({
    target: "_blank"
});
//const emojiPlugin = createEmojiPlugin();
const emojiPlugin = createEmojiPlugin({
    useNativeArt: false, selectButtonContent: <svg width="23" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0002 20.6668C16.0628 20.6668 20.1668 16.5628 20.1668 11.5002C20.1668 6.43755 16.0628 2.3335 11.0002 2.3335C5.93755 2.3335 1.8335 6.43755 1.8335 11.5002C1.8335 16.5628 5.93755 20.6668 11.0002 20.6668Z" stroke="#006EFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M7.3335 13.3335C7.3335 13.3335 8.7085 15.1668 11.0002 15.1668C13.2918 15.1668 14.6668 13.3335 14.6668 13.3335" stroke="#006EFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M8.25 8.75H8.2575" stroke="#006EFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M13.75 8.75H13.7575" stroke="#006EFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
});
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
const text = "hi";
const ext_arr = ["jpeg", "jpg", "png", "gif", "heic"];
//const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''));

class DraftJsEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            isMentionsOpen: false,
            //      suggestions:mentionData,
            suggestions: this.props.mentionuserArr,
            postType: [],
            attached_file: {},
            //      attached_file: [],
            attached_file_key: [],
            errors: {},
            removed_file: [],
            loading: false,
            contentloading: false,
            requestTime: "",
            mentionData: [],
            textCount: 0,
            uploaded_file: [],
            existing_file: [],
            empty_txt: "",
            isFormToggled: false,
            attached_video: [],
            urlValue: "",
            inputValue: ""
        }
        this.showImagePreview = this.showImagePreview.bind(this);
        this.showVideoPreview = this.showVideoPreview.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.onURLChange = this.onURLChange.bind(this);
        this.hideBox = e => this.setState({ urlValue: "", inputValue: "", isFormToggled: false, errors: {} }, function () {
        });
    }
    onURLChange(e) {
        var input_val = e.target.value;
        this.setState({ inputValue: input_val });
        var errors = this.state.errors;
        errors['video_extension'] = "";
        this.setState({ errors });
        if (input_val.includes("iframe")) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(input_val, 'text/html');
            // Find the iframe element in the parsed input
            var iframeselect = doc.querySelector('iframe');
            var iframeSrc = iframeselect.src;
            this.setState({ urlValue: iframeSrc });
        } else {
            this.setState({ urlValue: input_val });
        }
    }
    showVideoPreview(e) {
        var urlValue = this.state.urlValue;
        var errors = this.state.errors;
        if (urlValue) {
            this.setState({ attached_video: [], "contentloading": true }, function () {
                if (urlValue.match(/^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-.,@?^=%&:/~+#]*)?(\/embed\/)([\w-.,@?^=%&:/~+#]*)?$/)) {
                    // Confirmed as iframe
                    var attached_video = this.state.attached_video;
                    const embed_post = { type: "embed", url: this.state.urlValue };
                    attached_video.push(embed_post);
                    errors['video_extension'] = "";

                    this.setState({
                        errors,
                        contentloading: false,
                        iframePreviewActive: true // Set flag to true
                    }, function () {
                        console.log('Iframe preview added:', this.state.attached_video);
                    });
                } else {
                    // Handle non-iframe URLs
                    var attached_video = this.state.attached_video;
                    const embed_post = { type: "post" };
                    const fd1 = new FormData();
                    fd1.append("url", urlValue);
                    fetch(process.env.REACT_APP_CRM + '/url/preview', {
                        method: 'POST',
                        body: fd1
                    })
                        .then(response => response.json())
                        .then(findresponse => {
                            if (findresponse) {
                                if (findresponse.error) {
                                    if (findresponse.error === "REQUEST_TIMEOUT") {
                                        errors['video_extension'] = "Request timeout. Please try again later.";
                                    } else {
                                        errors['video_extension'] = "Too many requests. Please wait and try again.";
                                    }
                                    this.setState({ errors, contentloading: false });
                                } else {
                                    embed_post.meta = findresponse;
                                    embed_post.url = findresponse.url || "";
                                    attached_video.push(embed_post);
                                    errors['video_extension'] = "";
                                    this.setState({ errors, contentloading: false }, function () {
                                        console.log('Metadata fetched:', this.state.attached_video);
                                    });
                                }
                            } else {
                                errors['video_extension'] = "Too many requests. Please wait and try again.";
                                this.setState({ errors, contentloading: false });
                            }
                        });
                }
            });
        } else {
            errors['video_extension'] = "This field is required.";
            this.setState({ errors });
        }
    }

    handleToggle() {
        this.setState(prevState => ({
            isFormToggled: !prevState.isFormToggled
        }));
    }

    fetchPreview = () => {
        const { urlValue, fetchingPreview } = this.state;
        const errors = { ...this.state.errors };

        if (!urlValue || fetchingPreview) return;

        this.setState({ attached_video: [], contentloading: true, fetchingPreview: true }, () => {
            const embedUrlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-.,@?^=%&:/~+#]*)?(\/embed\/)([\w-.,@?^=%&:/~+#]*)?$/;

            if (embedUrlRegex.test(urlValue)) {
                const attached_video = [...this.state.attached_video];
                const embed_post = {
                    type: "embed",
                    url: urlValue
                };
                attached_video.push(embed_post);

                errors['video_extension'] = "";
                this.setState({ attached_video, errors, contentloading: false, fetchingPreview: false }, () => {
                    console.log("Embed detected:", this.state.attached_video);
                });
            } else {
                const fd1 = new FormData();
                fd1.append("url", urlValue);

                fetch(process.env.REACT_APP_CRM + '/url/preview', {
                    method: 'POST',
                    body: fd1
                })
                    .then(response => response.json())
                    .then(findresponse => {
                        if (findresponse) {
                            if (findresponse.error) {
                                errors['video_extension'] = findresponse.error === "REQUEST_TIMEOUT"
                                    ? "Request timeout. Please try again later."
                                    : "Too many requests. Please wait and try again.";
                                this.setState({ errors, contentloading: false, fetchingPreview: false });
                            } else {
                                const attached_video = [...this.state.attached_video];
                                const embed_post = {
                                    type: "post",
                                    meta: findresponse,
                                    url: findresponse.url || urlValue
                                };
                                attached_video.push(embed_post);

                                const previewHasImage = findresponse.images && findresponse.images.length > 0;

                                errors['video_extension'] = "";
                                this.setState({
                                    attached_video,
                                    errors,
                                    contentloading: false,
                                    fetchingPreview: false,
                                    previewHasImage,
                                }, () => {
                                    if (!previewHasImage) {
                                        console.log('No image found in the fetched metadata preview.');
                                    }
                                });
                            }
                        } else {
                            errors['video_extension'] = "Too many requests. Please wait and try again.";
                            this.setState({ errors, contentloading: false, fetchingPreview: false });
                        }
                    })
                    .catch(error => {
                        errors['video_extension'] = "Failed to fetch URL preview. Please try again.";
                        this.setState({ errors, contentloading: false, fetchingPreview: false });
                    });
            }
        });
    }

    onChange1 = (editorState) => {
        const currentContent = editorState.getCurrentContent().getPlainText('\u0001').trim();
        const errors = { ...this.state.errors };
        const txtLimit = this.props.isComment ? 500 : 1000;

        this.setState({ editorState, empty_txt: 0, textCount: currentContent.length });

        if (currentContent.length > txtLimit) {
            errors['text_limit_error'] = `Text limit should not exceed ${txtLimit} characters`;
        } else {
            $(".editors").css("border", "none");
            errors['text_limit_error'] = "";
        }

        const urlRegex = /((https?|ftp):\/\/(?:www\.)?[-\w@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/g;
        const urlMatch = currentContent.match(urlRegex);

        console.log('URLs found:', urlMatch);

        if (urlMatch && urlMatch.length > 0) {
            this.handleUrlDetection(currentContent, urlMatch);
        } else {
            this.handleUrlDetection(currentContent, []);
            this.setState({ errors });
        }
    }

    isValidUrl = (url) => {
        const urlRegex = /((https?|ftp):\/\/(?:www\.)?[-\w@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/g;
        return urlRegex.test(url);
    };

    handleUrlDetection = (currentContent, urlMatch) => {
        console.log('Current Content:', currentContent);
        console.log('handleUrlDetection called');

        if (this.state.iframePreviewActive) {
            return;
        }

        const cleanUrls = urlMatch ? urlMatch.map(url => url.replace(/\x01/g, '')) : [];
        let uniqueUrls = [...new Set(cleanUrls)].filter(url => this.isValidUrl(url));

        if (uniqueUrls.length === 0) {
            console.log('All URLs removed, resetting preview.');
            this.setState({
                previewFetched: false,
                urlValue: null,
                attached_video: [],
            });
            return;
        }

        if ((!uniqueUrls.includes(this.state.urlValue) || !this.state.previewFetched)) {
            this.setState({
                urlValue: uniqueUrls[0] || null,
                attached_video: [],
                previewFetched: true,
            }, () => {
                const iframeRegex = /<iframe.*<\/iframe>/i;
                if (!iframeRegex.test(currentContent)) {
                    this.fetchPreview();
                } else {
                    console.log('Iframe detected, skipping preview fetch.');
                }
            });
        } else {
            const currentUrlIndex = uniqueUrls.indexOf(this.state.urlValue);
            if (currentUrlIndex === -1) {
                this.setState({
                    urlValue: null,
                    previewFetched: false,
                    attached_video: [],
                }, () => {
                    if (uniqueUrls.length > 0) {
                        this.setState({
                            urlValue: uniqueUrls[0] || null,
                            previewFetched: true,
                        }, () => {
                            this.fetchPreview();
                        });
                    }
                });
            } else {
                const { previewHasImage } = this.state;

                if (!previewHasImage) {
                    uniqueUrls = uniqueUrls.filter(url => url !== this.state.urlValue);
                    const nextText = uniqueUrls[0];
                    const isUrl = /https?:\/\/[^\s]+/.test(nextText);
                    if (isUrl) {
                        this.setState({
                            urlValue: null,
                            previewFetched: false,
                            attached_video: [],
                        }, () => {
                            if (uniqueUrls.length > 0) {
                                this.setState({
                                    urlValue: isUrl ? nextText : null,
                                    previewFetched: true,
                                }, () => {
                                    this.fetchPreview();
                                });
                            }
                        });
                    }
                }
            }
        }
    };

    resetIframePreviewFlag = () => {
        this.setState({ iframePreviewActive: false });
    }
    onSeachChange1 = (srchval) => {
        if (srchval.value) {
            this.setState({
                suggestions: defaultSuggestionsFilter(srchval.value, this.props.mentionuserArr, srchval.trigger)
            });
        } else {
            this.setState({ suggestions: this.props.mentionuserArr });
        }
        //      this.setState({isMentionsOpen:false});
    }
    onOpenChange1 = (_open) => {
        this.setState({ isMentionsOpen: _open });
    }

    onAddMention = () => {
        //      alert(this.state.isMentionsOpen)
    }

    focus = () => {
        this.editor.focus();
    };

    saveEditorData = () => {
        this.setState({ iframePreviewActive: false });
        var d1 = this.state.attached_file.some(function (it) {
            return it.err != "";
        });
        if (d1) {
            $("#bol_btn").prop("disabled", true);
            return false;
        }
        if (this.state.errors && this.state.errors.hasOwnProperty('file_extension')) {
            if (this.state.errors.file_extension != "") {
                $("#bol_btn").prop("disabled", true);
                return false;
            }
        }

        const contentState = this.state.editorState.getCurrentContent();
        const text = contentState.getPlainText().trim();
        if (text === '') {
            this.focus();
            this.setState({ empty_txt: 1 });
            return false;
        }
        var editor_text_count = this.state.textCount;
        $("#bol_btn").prop("disabled", true);
        var txt_limit = this.props.isComment ? 500 : 1000;
        if (editor_text_count > txt_limit) {
            var errors = this.state.errors;
            errors['text_limit_error'] = "Text limit should not exceed " + txt_limit + " characters";
            this.setState({ errors });
            $("#bol_btn").prop("disabled", false);
            return false;
        }

        var post_data = [];
        const post_data_obj = {};
        const attached_file = {};
        const fd = new FormData;
        if (!this.props.isComment) {
            var file_cnt = this.state.attached_file.length;
            if (file_cnt > 0) {
                if (file_cnt < 11) {
                    fd.append("requestTime", this.props.apiRequestTime);
                    if (this.props.edit_post_add) {
                        for (var x = 0; x < this.state.uploaded_file.length; x++) {
                            fd.append("preview_images[]", this.state.uploaded_file[x]);
                        }
                        fd.append("attachment_files", JSON.stringify(this.state.uploaded_file));
                    } else {
                        for (var x = 0; x < this.state.attached_file.length; x++) {
                            fd.append("preview_images[]", this.state.uploaded_file[x]);
                        }
                        fd.append("attachment_files", JSON.stringify(this.state.attached_file));
                    }
                    for (var y = 0; y < this.state.attached_file.length; y++) {
                        attached_file[y + "_" + this.props.apiRequestTime] = this.state.attached_file[y];
                    }
                    post_data_obj.attachment_files = attached_file;
                } else {
                    this.showMaxLimitErr();
                }
            }
            if (this.state.removed_file.length > 0) {
                fd.append("removed_file", this.state.removed_file);
            }
            var checkboxValues = [];
            $('.bolType:checked').map(function () {
                checkboxValues.push($(this).val());
            });
            var post_type = checkboxValues;
            post_data_obj.post_type = post_type;

            var video_cnt = this.state.attached_video.length;
            console.log(237, video_cnt)
            if (video_cnt > 0) {
                console.log(237, this.state.attached_video)
                fd.append("embedded_urls", JSON.stringify(this.state.attached_video));
                post_data_obj.embedded_post = this.state.attached_video;
            }
        } else {
            post_data_obj.post_type = this.props.bol_type;
            post_data['post_type'] = this.props.bol_type;
        }
        post_data_obj.post_id = this.props.post_id ? parseInt(this.props.post_id) : "";
        post_data_obj._id = this.props.post_id ? parseInt(this.props.post_id) : "";
        post_data_obj.user_id = this.props.userId;
        post_data_obj.post_by = this.props.userId;

        var is_comment = this.props.isComment;
        var post_id = this.props.post_id ? parseInt(this.props.post_id) : "";
        var user_id = this.props.userId;
        var userEmail = this.props.userEmail;
        //        var uploaded_file = this.state.attached_file;
        var current_content = this.state.editorState.getCurrentContent();
        const rawEditorContent = convertToRaw(current_content);
        const draft_js_content = JSON.stringify(rawEditorContent);
        let html = stateToHTML(this.state.editorState.getCurrentContent());
        let original_html = html;
        const entityMap = rawEditorContent.entityMap;
        var mention_data = [];
        Object.values(entityMap).map(entity => {
            if (entity.data.mention !== undefined) {
                mention_data.push(entity.data.mention);
            }
        });

        var hash_tags = [];
        var hash_tags_new = extractHashtagsWithIndices(original_html);
        if (hash_tags_new != null && hash_tags_new.length > 0) {
            for (var i = 0; i < hash_tags_new.length; i++) {
                if (hash_tags_new[i]) {
                    hash_tags.push(hash_tags_new[i].hashtag);
                    var replace_tag = "#" + hash_tags_new[i].hashtag;
                    original_html = original_html.replace(replace_tag, "<span>#" + hash_tags_new[i].hashtag + "</span>");
                }
            }
        }

        var linkifys = extractLinks(original_html);
        const parser = new DOMParser();

        if (linkifys && linkifys.length > 0) {
            const doc = parser.parseFromString(original_html, "text/html");
            const aTags = doc.getElementsByTagName("a");
            for (let i = 0; i < aTags.length; i++) {
                const aTag = aTags[i];
                if (!aTag.hasAttribute("target")) {
                    aTag.setAttribute("target", "_blank");
                }
            }
            original_html = doc.body.innerHTML;
        }

        if (linkifys && linkifys.length > 0) {
            for (let i = 0; i < linkifys.length; i++) {
                if (linkifys[i]) {
                    var replace_link = linkifys[i].url;
                    if (!original_html.includes(`<a href="${replace_link}"`)) {
                        original_html = original_html.replace(replace_link, `<a target='_blank' href='${replace_link}'>${replace_link}</a>`);
                    }
                }
            }
        }

        if (mention_data != null && mention_data.length > 0) {
            for (var i = 0; i < mention_data.length; i++) {
                if (mention_data[i]) {
                    var replace_str = "@" + mention_data[i].name;
                    original_html = original_html.replace(replace_str, "<a target='_blank' href='/viewEmployee/" + mention_data[i].id + "'>@" + mention_data[i].name + "</a>");
                }
            }
        }
        original_html = original_html.replace(/<p><br[\/]?><[\/]?p>/g, '');
        let post_to_save = original_html;
        fd.append("user_id", user_id);
        fd.append("post_type", post_type);
        fd.append("post_id", post_id);
        if (this.props.edit_post_add) {
            fd.append("edit_post_id", post_id);
        }
        if (is_comment) {
            if (this.props.edit_post_add) {
                fd.append("follow_relation_type", this.props.postContentEdit.post_type);
            }
        } else {
            fd.append("follow_relation_type", post_type);
        }
        fd.append("email_id", userEmail);
        fd.append("is_my_post", 1);
        fd.append("message", post_to_save);
        fd.append("is_comment", is_comment);
        fd.append("post_by", user_id);
        fd.append("draft_js_content", draft_js_content);
        fd.append("original_html", original_html);
        fd.append("hash_tags", hash_tags);
        fd.append("mention_data", JSON.stringify(mention_data));
        post_data_obj.post = post_to_save;
        post_data_obj.comment_list = [null];
        post_data_obj.comment_list_count = "";
        post_data_obj.has_parent = false;
        post_data_obj.hash_tags = hash_tags;
        post_data_obj.is_comment = 0;
        post_data_obj.is_liked = 0;
        post_data_obj.draft_js_content = rawEditorContent;
        post_data_obj.original_html = original_html;
        if (is_comment) {
            if (this.props.edit_post_add) {
                post_data_obj.post_type = this.props.postContentEdit.post_type;
                post_data_obj.follow_relation_type = this.props.postContentEdit.post_type;
            }
        } else {
            post_data_obj.post_type = post_type;
            post_data_obj.follow_relation_type = post_type;
        }
        if (this.props.edit_post_add) {
            post_data_obj.edit_post_id = this.props.post_id ? this.props.edit_post_add : "";
            post_data_obj.posted_on = this.props.postContentEdit.posted_on;
        } else {
            fd.append("temp_post_id", this.props.apiRequestTime);
            post_data_obj.edit_post_id = "";
            post_data_obj._id = this.props.apiRequestTime;
            post_data_obj.post_id = this.props.apiRequestTime;
            post_data_obj.posted_on = "Just Now";
        }
        post_data_obj.comment_list = [];
        post_data_obj.likes_by = [];
        post_data_obj.likes = 0;
        post_data_obj.bolIndex = this.props.bolIndex;
        post_data.push(post_data_obj);
        var created_date = moment().utcOffset(0, false).format();
        var local_date = moment(created_date).local().format("YYYY-MM-DD HH:mm:ss");
        if (created_date) {
            fd.append("created_date", created_date);
            post_data_obj.created_date = created_date;
        }
        if (!this.props.edit_post_add) {
            if (this.props.bol_type_new.includes(1) && post_data_obj.post_type == 1) {
                this.props.addBol(this.props.userId, post_data_obj, 1, this.props.edit_post_add, this.props.bolIndex);
            } else if (this.props.bol_type_new.includes(2) && post_data_obj.post_type == 2) {
                this.props.addBol(this.props.userId, post_data_obj, 2, this.props.edit_post_add, this.props.bolIndex);
            }
        } else {
            $("#attachments").val("");
        }
        if (is_comment) {
            this.props.saveModifiedCommentDataP(post_data_obj, this.props.commentIndex);
            window.$("#add-happen").modal('hide');
            this.forceUpdate();
        } else {
            if (!this.props.edit_post_add) {
                window.$("#add-happen").modal('hide');
            }
        }

        try {
            fetch(this.props.bolApi + '/bol/savePost', {
                method: 'POST',
                dataType: 'json',
                body: fd
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $("#bol_btn").prop("disabled", false);
                    var removed_file = [];
                    var uploaded_file = [];
                    var attached_file = [];
                    this.setState({ removed_file, uploaded_file, attached_file });
                    if (findresponse.code == 200) {
                        post_data_obj._id = findresponse.post_id;
                        post_data_obj.post_id = findresponse.post_id;
                        this.setState({ showModal: false });
                        if (!is_comment) {
                            window.$("#add-happen").modal('hide');
                            this.props.fetchMyBols(this.props.userId, 1, 0);
                            // if (this.props.edit_post_add) {
                                // if (this.props.bol_type_new.includes(1)) {
                                // } else if (this.props.bol_type_new.includes(2)) {
                                //     this.props.fetchMyBols(this.props.userId, 2, 0);
                                // }
                            // }
                        }
                    } else if (findresponse.code == 500) {//alert(4)
                        this.focus();
                        $(".editors").css("border", "1px #006efa solid");//alert(this.state.postType.length)
                        if (this.state.postType.length == 0) {
                            var errors = this.state.errors;
                            errors['bol_type'] = "Choose bol type";
                            this.setState({ errors });
                            $("#bol_btn").prop("disabled", false);
                            return false
                        } else {
                            var errors = this.state.errors;
                            errors['bol_type'] = "";
                            this.setState({ errors });
                        }
                        return false;
                    }
                });
        } catch (error) {
            var errors = this.state.errors;
            if (!error.message) {
                // Network error occurred
                console.error('Network error:', error);
                errors['network_err'] = "Network error issue";
                this.setState({ errors });
            } else {
                // The server responded with a status other than 200 range
                console.error('Error response:', error.message);
                errors['network_err'] = error.message;
                this.setState({ errors });
            }
        }
    }
    chkExtension(file) {
        var extension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        var errors = this.state.errors;
        if (ext_arr.includes(extension)) {
            var file_size = file.size;
            var img_size = Math.round(file_size / Math.pow(1024, 2));
            if (img_size > 20) {
                var errors = this.state.errors;
                $("#attachments").val("");
                this.setState({ loading: false });
                errors['file_extension'] = "Maximum upload file size : 20MB";
                this.setState({ errors: errors });
                $("#bol_btn").prop("disabled", false);
                return false;
            } else {
                return true;
            }
        } else {
            $("#attachments").val("");
            this.setState({ loading: false });
            errors['file_extension'] = "Supported image formats : jpg,png,gif";
            this.setState({ errors: errors });
            $("#bol_btn").prop("disabled", false);
            return false;
        }
    }

    showMaxLimitErr() {
        $("#attachments").val("");
        this.setState({ loading: false });
        var errors = this.state.errors;
        errors['file_extension'] = "Maximum image count : 10";
        this.setState({ errors: errors });
        setTimeout(() => {
            var div = document.querySelector("#server_upload_err");
            if (div) {
                div.scrollIntoView({ behavior: 'smooth' });
            }
        }, 500);
        $("#bol_btn").prop("disabled", false);
        return false;
    }

    // Function to add a new column to array1 based on matching id in array2
    addColumnBasedOnMatch(array1, array2, matchField, newField) {
        // Create a mapping of ids to corresponding objects in array2
        const idToObjectMap = {};
        array2.forEach(obj => {
            idToObjectMap[obj[matchField]] = obj;
        });
        // Map through array1 and add a new field if there's a match
        const newArray1 = array1.map(obj1 => {
            const matchingObj2 = idToObjectMap[obj1[matchField]];
            if (matchingObj2) {
                return { ...obj1, [newField]: matchingObj2[newField] };
            } else {
                return { ...obj1 }; // No match found, return original object
            }
        });

        return newArray1;
    }

    showImagePreview(e) {
        this.setState({ "loading": true });
        var user_id = this.props.userId;
        var selectedFIles = [];
        var file_cnt = document.getElementById('attachments').files.length;
        const fd = new FormData;
        for (var x = 0; x < file_cnt; x++) {
            var file = document.getElementById('attachments').files[x];
            //            var file_type = file.type.split("/")[0];
            //            if(file_type == "image"){
            fd.append("files_upload[]", document.getElementById('attachments').files[x]);
            //            }
        }
        if (file_cnt > 0) {
            if (file_cnt < 11) {
                var existing_file = this.state.attached_file;
                var targetFiles = e.target.files;
                var upload_file_exist = (this.props.edit_post_add) ? this.state.attached_file.length : this.state.uploaded_file.length;
                var current_file_cnt = e.target.files.length;
                var total_file_cnt = upload_file_exist + current_file_cnt;
                if (total_file_cnt < 11) {
                    var resultant_arr = [...this.state.uploaded_file, ...e.target.files];
                    this.setState({ uploaded_file: resultant_arr });
                    if (upload_file_exist < 11) {
                        var targetFilesObject = [...targetFiles];
                        targetFilesObject.map((file, k) => {
                            //                                var chk_ext = this.chkExtension(file);
                            //                                if(chk_ext){
                            return selectedFIles.push({ 'file_name': file.name, 'file_uuid': k + "_" + this.props.apiRequestTime, 'file_url': URL.createObjectURL(file) });
                            //                                }else{
                            //                                    var errors = this.state.errors;
                            //        this.setState({loading:false});
                            //                                    errors['file_extension'] = "Supported image formats : jpg,png,gif";
                            //        this.setState({errors: errors});
                            //        return false;
                            //  }
                        });
                        var existing_files = [...this.state.attached_file];
                        var new_files = existing_files.concat(selectedFIles);
                        //validating image
                        var rr = new_files, existing_file;
                        var rr1 = [];
                        var errors = this.state.errors;
                        try {
                            fetch(this.props.bolApi + '/Bol/validateImage', {
                                method: 'POST',
                                dataType: 'json',
                                body: fd
                            })
                                .then((Response) => Response.json())
                                .then((findresponse) => {
                                    findresponse = this.rawjsonparse(findresponse, 1);
                                    this.setState({ "loading": false });
                                    if (findresponse.code != 500) {
                                        errors['network_err'] = "";
                                        const newArray1 = this.addColumnBasedOnMatch(selectedFIles, findresponse.res, 'file_name', 'err');
                                        const newArray2 = this.addColumnBasedOnMatch(newArray1, findresponse.res, 'file_name', 'uploadOk');
                                        var nr = existing_files.concat(newArray2);
                                        this.setState({ attached_file: nr, errors }, function () {
                                        });
                                    } else {
                                        errors['network_err'] = "Exceeding max file upload size.Please try again";
                                        this.setState({ errors });
                                    }
                                }).catch(function (err) {
                                    errors['network_err'] = err;
                                    this.setState({ errors });
                                });
                        } catch (err1) {
                            errors['network_err'] = err1.message;
                            this.setState({ errors });
                        }
                    } else {
                        this.showMaxLimitErr();
                    }
                } else {
                    this.showMaxLimitErr();
                }
            } else {
                this.showMaxLimitErr();
            }
        }

    }
    removeVideo() {
        this.setState({ attached_video: [], urlValue: "", inputValue: "", isFormToggled: false, errors: {} }, function () {
            console.log(563, this.state.attached_video);
        });
    }

    removeFile(e, key, file_uuid) {
        var attachment_arr = this.state.attached_file;
        var removed_file = this.state.removed_file;
        attachment_arr.splice(key, 1);
        if (file_uuid) {
            removed_file.push(file_uuid);
            this.setState({ removed_file });
        }
        this.setState({ attached_file: attachment_arr, uploaded_file: attachment_arr }, function () {
        });
        $("#attachments").val("");
    }
    setPostType = (e) => {
        var targetId = e.target.id;
        var post_type = this.state.postType;
        if ($("#" + targetId).is(":checked")) {
            post_type = e.target.value;
            this.setState({ postType: post_type });
        }
    }

    hideErrorBox = (e, key_to_remove, div_id) => {
        if (key_to_remove != "" && key_to_remove > -1) {
            var attached_files = this.state.attached_file;
            var x = attached_files.splice(key_to_remove, 1);
            this.setState({ attached_file: attached_files }, function () {
            });
        } else {
            $("#server_upload_err_" + key_to_remove).hide();
        }
        //        $("#"+div_id).hide();
        var errors = this.state.errors;
        if (errors['file_extension'] == "Maximum image count : 10") {
            errors['file_extension'] = "";
        } else if (errors['file_extension'] == "Maximum upload file size : 20MB") {
            errors['file_extension'] = "";
        }
        this.setState({ errors });
        $("#bol_btn").prop("disabled", false);
    }
    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps !== this.props) {
            if (this.props.edit_post_add) {
                if (this.props.isComment) {
                    this.setState({
                        editorState: EditorState.createWithContent(convertFromRaw(this.props.postContentEdit.draft_js_content)),
                        attached_file: []
                    });
                } else {
                    var postType = this.props.postContentEdit.post_type;
                    if (postType) {
                        this.setState({ postType: this.props.bol_type_new, removed_file: [] }, function () {
                        });
                    }
                    var attachment_video = [];
                    if (this.props.postContentEdit.hasOwnProperty('embedded_post')) {
                        if (this.props.postContentEdit.embedded_post !== undefined) {
                            for (var i = 0; i < this.props.postContentEdit.embedded_post.length; i++) {
                                attachment_video[i] = this.props.postContentEdit.embedded_post[i];
                                if (this.props.postContentEdit.embedded_post[i].hasOwnProperty('url')) {
                                    this.setState({ isFormToggled: true, inputValue: this.props.postContentEdit.embedded_post[i].url });
                                }
                            }
                        }
                    }
                    var attachment_arr = [];
                    if (this.props.postContentEdit.hasOwnProperty('attachment_files')) {
                        if (this.props.postContentEdit.attachment_files !== undefined) {
                            var existing_attached_value = Object.values(this.props.postContentEdit.attachment_files);
                            if (Object.keys(this.props.postContentEdit.attachment_files).length > 0) {
                                for (var i = 0; i < Object.keys(this.props.postContentEdit.attachment_files).length; i++) {
                                    attachment_arr[i] = existing_attached_value[i];
                                    attachment_arr[i].err = "";
                                    attachment_arr[i].uploadOk = 1;
                                }
                            }
                        }
                    }
                    this.setState({
                        editorState: EditorState.createWithContent(convertFromRaw(this.props.postContentEdit.draft_js_content)),
                        attached_file: attachment_arr, attached_video: attachment_video, errors: {}
                    });
                }
            } else {
                var post_type = this.props.bol_type_new;//["1"];
                const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''));
                this.setState({
                    ...this.state,
                    editorState,
                    attached_file: [], attached_video: [], uploaded_file: [], errors: {},
                    loading: false, postType: post_type, isFormToggled: false, urlValue: '', inputValue: ''
                });
                $(".editors").css("border", "unset");
                $("#life").prop('checked', false);
            }
        }
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }


    render() {
        return (
            <div className="editorContainer">
                {this.props.isComment && !this.props.edit_post_add ?
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="topic-text">
                                <div class="normal-text" dangerouslySetInnerHTML={{ __html: this.props.postContentEdit.post }}>
                                </div>
                            </div>
                        </div>
                    </div> : ""}

                {this.props.isComment && !this.props.edit_post_add ?
                    <div class="row mt15">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="reply-item">
                                <div class="smallimg-box left">
                                    {this.props.attachment ? <img src={this.props.attachment} /> : <div class="circle-firstletter">{this.props.userName.charAt(0).toUpperCase()}</div>}
                                </div>
                            </div>
                        </div>
                    </div> :
                    <div class={`upper-div` + (this.state.empty_txt ? ' empty-editor' : '')} id="upper-div">
                        <div className="editors sec_div" onClick={this.focus}>
                            <Editor
                                editorState={this.state.editorState}
                                onChange={this.onChange1}
                                plugins={!this.props.isComment ? [linkifyPlugin, hashtagPlugin, emojiPlugin, mentionPlugin] : [emojiPlugin]}
                                ref={editor => {
                                    this.editor = editor;
                                }}
                                placeholder={!this.props.isComment ? "Add your post here" : "Bol your reply"}
                            />
                        </div>
                        <MentionSuggestions
                            suggestions={this.state.suggestions}
                            onSearchChange={this.onSeachChange1}
                            onOpenChange={this.onOpenChange1}
                            open={this.state.isMentionsOpen}
                            onAddMention={this.onAddMention}
                        />
                    </div>
                }
                <div class="error-message">{this.state.errors.text_limit_error}</div>
                {/*<div class="loader-new" id="loader-new"></div>*/}
                <div class={this.state.loading ? "bolbox-overlay" : ""} >
                    {this.state.loading ?
                        <div class="loader_bol">
                            <div>
                                <div>
                                    <svg class="loader_addhappen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 33">
                                        <g stroke-width="1" fill="none" fill-rule="evenodd">
                                            <path class="cloud" d="M45,22.7331459 C45,19.1499462 42.7950446,16.079593 39.6628004,14.7835315 C39.6774469,14.5246474 39.7003932,14.2674038 39.7003932,14.0035978 C39.7003932,6.82243304 33.8412885,1 26.611593,1 C21.3985635,1 16.9102123,4.03409627 14.8051788,8.41527616 C13.7828502,7.62878013 12.503719,7.15547161 11.1134367,7.15547161 C7.77825654,7.15547161 5.07450503,9.84159999 5.07450503,13.1544315 C5.07450503,13.7760488 5.16938207,14.3779791 5.3477444,14.9418479 C2.74863428,16.4787471 1,19.2867709 1,22.5105187 C1,27.3287502 4.89630545,31.2367856 9.72803666,31.31094 L36.3341301,31.3109406 C41.1201312,31.3406346 45,27.4870665 45,22.7331459 L45,22.7331459 Z" stroke-linejoin="round"></path>
                                            <path class="loop" d="M25.3570852,17.8208603
                                    C26.0154526,17.1207706 27.1652748,15.6666667 29.5167986,15.6666667
                                    C32.1278053,15.6666667 34.2444444,17.6366138 34.2444444,20.0666667
                                    C34.2444444,22.4967196 32.1278053,24.4666667 29.5167986,24.4666667
                                    C26.9249697,24.4666667 24.5595344,21.7145959 23.4888889,20.543316
                                    C21.4404656,18.4187374 19.0750303,15.6666667 16.4832014,15.6666667
                                    C13.8721947,15.6666667 11.7555556,17.6366138 11.7555556,20.0666667
                                    C11.7555556,22.4967196 13.8721947,24.4666667 16.4832014,24.4666667
                                    C18.8347252,24.4666667 19.9845474,23.0125628 20.6429148,22.312473
                                    L25.3570852,17.8208603" stroke-linecap="round"></path>
                                        </g>
                                    </svg>
                                </div>
                                <div class="shadow">Please wait while we upload your image</div>
                            </div>
                        </div> : ""}
                    {this.state.attached_file.length > 0 ?
                        <div class="imgbox-part">
                            <div class="row">
                                {(this.state.attached_file).map((item, key) => (
                                    item.uploadOk == 1 ?
                                        <div className="col-md-4 col-lg-4">
                                            <div className="box-img">
                                                <img src={item.file_url} />
                                                <div className="remove-img last" onClick={(e) => this.removeFile(e, key, item.file_uuid)}>
                                                    <span>
                                                        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.125 3.25L3.875 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M3.875 3.25L10.125 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-md-4 col-lg-4" id={`server_upload_err_${key}`}>
                                            <div className="box-img error-box">
                                                <div><p>{item.err}</p></div>
                                                <div className="remove-img" onClick={(e) => this.hideErrorBox(e, key, "server_upload_err_" + key)}>
                                                    <span>
                                                        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.125 3.25L3.875 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                            <path d="M3.875 3.25L10.125 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                )
                                )}
                                {this.state.errors.hasOwnProperty('file_extension') && this.state.errors.file_extension ?
                                    <div class="col-md-4 col-lg-4" id="ext_err">
                                        <div class="box-img error-box">
                                            <div><p>{this.state.errors.file_extension}</p></div>
                                            <div class="remove-img" onClick={(e) => this.hideErrorBox(e, "", "ext_err")}>
                                                <span>
                                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.125 3.25L3.875 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        <path d="M3.875 3.25L10.125 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                            </div>
                        </div>

                        : this.state.errors.hasOwnProperty('file_extension') && this.state.errors.file_extension ?
                            <div className="imgbox-part">
                                <div className="row">
                                    <div class="col-md-4 col-lg-4" id="ext_err">
                                        <div class="box-img error-box">
                                            <div><p>{this.state.errors.file_extension}</p></div>
                                            <div class="remove-img" onClick={(e) => this.hideErrorBox(e, "", "ext_err")}>
                                                <span>
                                                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.125 3.25L3.875 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        <path d="M3.875 3.25L10.125 9.5" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : ""}
                    <div className="error-message">{this.state.errors.hasOwnProperty('network_err') && this.state.errors.network_err}</div>

                </div>
                {/** start : video preview */}
                <div className={this.state.contentloading ? "bolbox-overlay" : ""} >
                    {this.state.contentloading ?
                        <Jscontentloader /> : ""}
                    {console.log("asa", this.state.attached_video.length)}
                    {this.state.attached_video.length > 0 &&
                        this.state.attached_video.some(item => item.type === "embed" || (item.meta)) ? (
                        <div className="preview-container">
                            {this.state.attached_video.map((item, key) => (
                                <div className="preview-item" key={key}>
                                    {item.type === "embed" ? (
                                        <div className="box-img">
                                            <iframe src={item.url} title="Embedded Video"></iframe>
                                        </div>
                                    ) : (
                                        item.meta.images && item.meta.images.length > 0 ? (
                                            <a href={item.meta && item.meta.url ? item.meta.url : '#'} target="_blank">
                                                <div className="preview-card">
                                                    <div className="preview-image">
                                                        <img
                                                            className="preview-item-image"
                                                            src={
                                                                item.meta && item.meta.images && item.meta.images.length > 0
                                                                    ? item.meta.images[0]
                                                                    : noImage
                                                            }
                                                            alt="Preview"
                                                        />
                                                    </div>
                                                    <div className="preview-content">
                                                        <h5 className="preview-item-title">
                                                            {item.meta && item.meta.title
                                                                ? item.meta.title.length > 60
                                                                    ? item.meta.title.substring(0, 60) + "..."
                                                                    : item.meta.title
                                                                : ''}
                                                        </h5>
                                                        <p className="preview-item-description">
                                                            {item.meta && item.meta.description
                                                                ? item.meta.description.length > 100
                                                                    ? item.meta.description.substring(0, 100) + "..."
                                                                    : item.meta.description
                                                                : ''}
                                                        </p>
                                                        <small className="preview-item-domain">
                                                            {item.meta && item.meta.favicon ? (
                                                                <img src={item.meta.favicon} alt="Domain Icon" />
                                                            ) : null}
                                                        </small>
                                                    </div>
                                                </div>
                                            </a>
                                        ) : (
                                            <a href={item.meta && item.meta.url ? item.meta.url : '#'} target="_blank">
                                                <div className="preview-card">
                                                    <div className="preview-content">
                                                        <h5 className="video-title preview-item-title">
                                                            <small className="preview-item-domain video-domain">
                                                                {item.meta && item.meta.favicon ? (
                                                                    <img src={item.meta.favicon} alt="Domain Icon" />
                                                                ) : null}
                                                            </small>
                                                            {item.meta && item.meta.title
                                                                ? item.meta.title.length > 60
                                                                    ? item.meta.title.substring(0, 60) + "..."
                                                                    : item.meta.title
                                                                : ''}
                                                        </h5>
                                                        <p className="preview-item-description">
                                                            {item.meta && item.meta.description
                                                                ? item.meta.description.length > 100
                                                                    ? item.meta.description.substring(0, 100) + "..."
                                                                    : item.meta.description
                                                                : ''}
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        )
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
                {/** end : video preview */}
                <div class={"row " + (this.state.isFormToggled ? "show" : "hide")}>
                    <div class="col-md-12">
                        <input type="text" class="url-input" placeholder="Paste your embed URL here" value={this.state.inputValue ? this.state.inputValue : ""} onChange={this.onURLChange} />
                        <button class="btn-primary confirm-btn" type="button" onClick={this.showVideoPreview}><i class="fa fa-check"></i></button>
                        <button class="btn-primary confirm-btn" type="button" onClick={(e) => this.removeVideo()} ><i class="fa fa-times"></i></button>
                    </div>
                    <div class="error">{this.state.errors && this.state.errors.video_extension}</div>
                </div>
                {/* {!this.props.isComment ?
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="all-tag">
                                <label className="switch">
                                    <input type="radio" name="post_type" className="bolType" id="work" value="1" onClick={(e) => this.setPostType(e)} checked={this.state.postType && this.state.postType.includes("1") ? "checked" : ""} defaultChecked={this.props.edit_post_add ? 0 : 1} />
                                    <span className="slider round">Work</span>
                                </label>
                                <label className="switch sm-switch">
                                    <input type="radio" name="post_type" className="bolType" id="life" value="2" onClick={(e) => this.setPostType(e)} checked={this.state.postType && this.state.postType.includes("2") ? "checked" : ""} />
                                    <span className="slider round">Life</span>
                                </label>
                            </div>
                        </div>
                    </div> : ""} */}
                <div className="error-message">{this.state.errors.bol_type}</div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="bottom-adding active">
                            <div className="uplading-item">
                                {!this.props.isComment ?
                                    <span className="upload-file" onChange={this.showImagePreview}>
                                        <svg width="23" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.4167 3.25H4.58333C3.57081 3.25 2.75 4.07081 2.75 5.08333V17.9167C2.75 18.9292 3.57081 19.75 4.58333 19.75H17.4167C18.4292 19.75 19.25 18.9292 19.25 17.9167V5.08333C19.25 4.07081 18.4292 3.25 17.4167 3.25Z" stroke="#006EFA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M7.79199 9.6665C8.55138 9.6665 9.16699 9.0509 9.16699 8.2915C9.16699 7.53211 8.55138 6.9165 7.79199 6.9165C7.0326 6.9165 6.41699 7.53211 6.41699 8.2915C6.41699 9.0509 7.0326 9.6665 7.79199 9.6665Z" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M19.2497 14.2498L14.6663 9.6665L4.58301 19.7498" stroke="#006EFA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                        <input id="file-input" multiple type="file" title="" name="attachments" id="attachments" className="hiddenup-file" accept="image/*" />
                                    </span> : ""}
                                <EmojiSuggestions />
                                <EmojiSelect />
                                {/* <div class="embed-btn">
                                <span onClick={this.handleToggle}>
                                    <svg width="22" height="22" viewBox="0 0 70 55" 
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M31.25 40.25H33.25C34.15 40.25 34.1 40.25 34.3 39.4L40 16.3C40.4 14.75 40.35 14.75 38.75 14.75H36.75C35.85 14.75 35.9 14.75 35.7 15.6L30 38.7C29.6 40.25 29.65 40.25 31.25 40.25ZM26.9 35.65L28.25 34.3C29.1 33.45 29.05 33.45 28.25 32.6L24.25 28.4C23.45 27.55 23.45 27.6 24.25 26.75L28.25 22.45C29.05 21.6 29.05 21.65 28.25 20.8L26.9 19.4C26.05 18.5 26 18.55 25.15 19.45L18.25 26.75C17.5 27.55 17.5 27.55 18.25 28.35L25.15 35.6C26 36.55 26 36.55 26.9 35.65ZM43.1 35.65C44 36.55 44 36.55 44.85 35.6L51.75 28.35C52.5 27.55 52.5 27.55 51.75 26.75L44.85 19.45C44 18.55 43.95 18.5 43.1 19.4L41.75 20.8C40.95 21.65 40.95 21.6 41.75 22.45L45.75 26.75C46.55 27.6 46.55 27.55 45.75 28.4L41.75 32.6C40.95 33.45 40.9 33.45 41.75 34.3L43.1 35.65ZM4 55H66C68.7 55 70 53.7 70 51V4C70 1.3 68.7 -8.19564e-07 66 -8.19564e-07H4C1.3 -8.19564e-07 0 1.3 0 4V51C0 53.7 1.3 55 4 55ZM5 50V45H10V50H5ZM5 40V35H10V40H5ZM5 30V25H10V30H5ZM5 20V15H10V20H5ZM5 10V5H10V10H5ZM15 50V5H55V50H15ZM60 50V45H65V50H60ZM60 40V35H65V40H60ZM60 30V25H65V30H60ZM60 20V15H65V20H60ZM60 10V5H65V10H60Z" fill="#04BAF2"/>
                                    </svg>
                                </span>
                        </div> */}
                            </div>
                            <button type="button" className="boladds-btn" id="bol_btn" onClick={this.saveEditorData} title="Submit">Bol</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DraftJsEditor;



// WEBPACK FOOTER //
// ./src/components/bol/DraftJsEditor.js